import _join from 'lodash/join';
import _isEmpty from 'lodash/isEmpty';
import Fuse from 'fuse.js';
import stopword from 'stopword';
import { getLanguage } from '../../helpers/twHelper';

const MAX_SEARCH_SIZE = 10;

const topicNodeFilter = (options = {}) => ({
  ...options.topicNode,
  parents: options.parents && options.parents.slice(),
});

const dfsHelper = (options) => {
  const topicNode = options.node;
  if (_isEmpty(topicNode)) {
    return;
  }

  // Find the leaf node and add to Search pool
  if (_isEmpty(topicNode.sub_topics) && topicNode.leaf_node && Array.isArray(options.parents)) {
    options.searchPool.push(topicNodeFilter({ topicNode, parents: options.parents }));
  }

  if (Array.isArray(topicNode.sub_topics)) {
    topicNode.sub_topics.forEach((subTopic) => {
      options.parents.push(subTopic.topic_name); // Push current topic name input parent array
      dfsHelper({ node: subTopic, parents: options.parents, searchPool: options.searchPool });
      options.parents.pop(); // Remove the last add topic name for recursive DFS search
    });
  }
};

const getFuseOptions = () => ({
  shouldSort: true,
  threshold: 0.4,
  location: 0,
  distance: 100,
  maxPatternLength: 10,
  minMatchCharLength: 1,
  keys: ['ref_id', 'topic_name', 'parents'],
});

export const topicSearchPool = (topicTreeRoot) => {
  const searchPool = [];
  dfsHelper({ node: topicTreeRoot, parents: [], searchPool });
  return searchPool;
};

// getSearchResult({ searchPool, query: 'money' });
// Get Search Result by using Fuse.js; options: searchPool, query. size
export const getSearchResult = (options = {}) => {
  const params = getFuseOptions();
  const query = options.query;
  const removeStopwordsArr = stopword.removeStopwords(query.split(' '), stopword[getLanguage()]);
  const finalQuery = _join(removeStopwordsArr, ' ');
  const searchPool = options.searchPool;
  const size = options.size || MAX_SEARCH_SIZE;

  if (query && Array.isArray(searchPool) && searchPool.length > 0) {
    const fuse = new Fuse(searchPool, params);
    const result = fuse.search(finalQuery).slice(0, size);
    const formatedResult = result.map((resVal) => {
      resVal.id = resVal.ref_id;
      resVal.value = resVal.topic_name;
      return resVal;
    });
    return formatedResult;
  }

  return null;
};
